import React, { useEffect } from 'react'
import { useSelector, useDispatch, Provider } from 'react-redux'
import { RouterProvider } from 'react-router5'

import Router from './router/Router'

import userSelectors from './store/selectors/user'
import userActions from './store/modules/user'
import routerSelectors from './store/selectors/router'
import routerActions from './store/modules/router'

const Root = ({
  store,
  router,
}) => {
  const dispatch = useDispatch()
  const initialised = useSelector(userSelectors.initialised)

  useEffect(() => {
    let initialUrl = ''
    firebase.auth().onAuthStateChanged(function(user) {
      router.start()
      if (user) {
        dispatch(userActions.setData({
          id: user.uid,
          displayName: user.displayName,
          email: user.email,
          credential: user.credential,
          photoURL: user.photoURL,
        }))
        const route = routerSelectors.route(store.getState())
        if(initialUrl && initialUrl.indexOf('login') < 0) {
          window.location = initialUrl
        }
        else if(route.name == 'login') {
          dispatch(routerActions.navigateTo('home')) 
        }
        initialUrl = ''
      } else {
        initialUrl = window.location.toString()
        dispatch(userActions.setData(null))
        dispatch(routerActions.navigateTo('login'))
      }
      dispatch(userActions.setInitialised(true))
    })
  }, [])

  if(!initialised) return null

  return (
    <RouterProvider router={ router }>
      <Router />
    </RouterProvider>
  )
}

export default Root
